import jQuery from 'jquery';
import 'magnific-popup';

jQuery(function ($) {
    'use strict';

    const closeModalSVG = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 0C8.94 0 0 8.94 0 20C0 31.06 8.94 40 20 40C31.06 40 40 31.06 40 20C40 8.94 31.06 0 20 0ZM25.18 12L20 17.18L14.82 12L12 14.82L17.18 20L12 25.18L14.82 28L20 22.82L25.18 28L28 25.18L22.82 20L28 14.82L25.18 12ZM4 20C4 28.82 11.18 36 20 36C28.82 36 36 28.82 36 20C36 11.18 28.82 4 20 4C11.18 4 4 11.18 4 20Z" fill="black"/></svg>';

    $('.video-modal').each(function () {
        const $link = $(this);

        $link.magnificPopup({
            type: 'iframe',
            midClick: true,
            iframe: {
                markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" referrerpolicy="strict-origin-when-cross-origin"></iframe>' +
                    '</div>',
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: 'v=',
                        src: $link.data('embed')
                    }
                }
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">' + closeModalSVG + '</button>'
        });
    });
});